import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API } from "@/App";

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(location.state?.user ? true : null);
  const [user, setUser] = useState(location.state?.user || null);
  
  useEffect(() => {
    // Skip auth check if user was passed from AuthCallback
    if (location.state?.user) {
      setUser(location.state.user);
      setIsAuthenticated(true);
      return;
    }
    
    const checkAuth = async () => {
      try {
        const response = await fetch(`${API}/auth/me`, {
          credentials: "include"
        });
        
        if (!response.ok) {
          throw new Error("Not authenticated");
        }
        
        const userData = await response.json();
        setUser(userData);
        setIsAuthenticated(true);
        
        // Redirect to onboarding if not completed
        if (!userData.onboarding_completed && location.pathname !== "/onboarding") {
          navigate("/onboarding", { state: { user: userData } });
        }
      } catch (error) {
        setIsAuthenticated(false);
        navigate("/");
      }
    };
    
    checkAuth();
  }, [navigate, location]);
  
  // Show loading while checking auth
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-full border-4 border-sky-200 border-t-sky-500 animate-spin" />
          <p className="text-slate-500 font-medium">Loading...</p>
        </div>
      </div>
    );
  }
  
  // Not authenticated - don't render children
  if (!isAuthenticated) {
    return null;
  }
  
  // Render children with user context
  return children;
}
